import { useEffect, useContext } from "react"
import { useNavigate } from "react-router-dom"
import BackButton from "../components/BackButton"
import { useLocation } from 'react-router-dom'
import Project from "../components/Project"
import LanguageContext from "../LanguageContext"

const DocumentSelectionView = ({ API_URL, selectedProjects, setSelectedProjects, setLoading, joinCode, debugLog, debugError }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const editCode = location.pathname.split("/")[1]
  const { texts } = useContext(LanguageContext)
  const t = texts.documentSelection

  useEffect(() => {
    if (selectedProjects.length === 0) {
      navigate(`/${editCode}/select-projects`)
    }
  }, [selectedProjects, navigate, editCode]);

  const handleBackToSelection = () => {
    navigate(`/${editCode}/select-projects`)
  }

  const createSelection = async () => {
    setLoading(true);
    const payload = {
      joinCode,
      editCode,
      documents: selectedProjects,
    };

    try {
      const response = await fetch(`${API_URL}/selections`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      debugLog("[DocumentSelectionView] Sending selection to db: ", payload)
      const data = await response.json();
      navigate(`/${editCode}/summary`)
      return data;
    } catch (error) {
      debugError("Error creating code:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="back-button">
        <BackButton handleFunction={handleBackToSelection} />
      </div>
      <div className="center-container">
        <h2>{t.select}</h2>
        <div className="page-instructions">
          <p>{t.instructions[0]}</p>
          <p>{t.instructions[1]}</p>
          <p>{t.instructions[2]}</p>
        </div>
        <h3>Valitut hankkeet:</h3>
        <ul>
          {selectedProjects.map((p, index) =>
            <div key={index}>
              <Project step={"document selection"} project={p} selectedProjects={selectedProjects} setSelectedProjects={setSelectedProjects} />
            </div>
          )}
        </ul>
      </div>
      <button className="continue-button" onClick={createSelection}>
        {t.saveButton}
      </button>
    </>
  )
}

export default DocumentSelectionView